import "isomorphic-fetch"

export const API = {
    getTranslations,
    getLanguages,
    getBorders,
    getBaseLayers,
    getLayers,
    getContentLinks,
    getContentLists,
    getContentLinksByGroup,
    getDataAllRegions,
    getDataOneRegion,
    getTrendsAllRegions,
    getStatsAllRegions,
    getExternalGeoLayers,
    getExternalGeofeatures
}



function _get( api_url ) {
  let headers = [];
  headers['Content-Type'] = 'text/plain';
  headers['Accept'] = 'application/json'

  const requestOptions = {
    method: 'GET',
    headers: headers
  }

  const url = process.env.REACT_APP_API_Url + api_url;

  return fetch(url, requestOptions)
    .then( response => {
      return response.text().then( text => {
        const data = text && JSON.parse(text)
        if (!response.ok) {
          const error = (data && data.message) || response.statusText;
          return Promise.reject(error);
        }

        return data;
      })

    })
    .catch( function(error) {
    });
}

function getTranslations(lang_code, group_title) {
  return _get('/trans/' + lang_code + '/' + group_title);
}

function getLanguages() {
  return _get('/config/langs');
}

function getBorders() {
  return _get('/config/borders');
}

function getBaseLayers() {
  return _get('/config/baselayers');
}

function getLayers() {
  return _get('/config/layers');
}

function getContentLinks() {
  return _get('/content/links');
}

function getContentLists() {
  return _get('/content/lists');
}

function getContentLinksByGroup( group ) {
  return _get('/content/links/' + group);
}

function getDataAllRegions( catagoryTitle ) {
  return _get('/data/' + catagoryTitle);
}

function getDataOneRegion( catagoryTitle, regionId) {
  return _get('/data/' + catagoryTitle + "/" + regionId);
}

function getTrendsAllRegions( categoryTitle ) {
  return _get('/trends/' + categoryTitle);
}

function getStatsAllRegions( categoryTitle ) {
  return _get('/stats/' + categoryTitle);
}

function getExternalGeoLayers( url ) {
  return _get('/externalgeo/layers?url=' + encodeURI(url));
}

function getExternalGeofeatures( url ) {
  return _get('/externalgeo/features?url=' + encodeURI(url));
}